/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './components/loader/loader.component.ngfactory';
import * as i3 from '../../app/components/loader/loader.component';
import * as i4 from '../../app/shared/_services/loader.service';
import * as i5 from '@angular/router';
import * as i6 from '../../app/app.component';
import * as i7 from '@ngx-translate/core/src/translate.service';
import * as i8 from '../../app/shared/_services/util.service';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(1,0,
      (null as any),(null as any),1,'angular-loader',([] as any[]),(null as any),(null as any),
      (null as any),i2.View_LoaderComponent_0,i2.RenderType_LoaderComponent)),i1.ɵdid(2,
      245760,(null as any),0,i3.LoaderComponent,[i4.LoaderService],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n '])),(_l()(),i1.ɵeld(4,0,(null as any),
          (null as any),4,'div',[['class','sandos-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i1.ɵeld(6,16777216,(null as any),(null as any),1,'router-outlet',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(7,212992,(null as any),0,i5.RouterOutlet,[i5.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    _ck(_v,2,0);
    _ck(_v,7,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(1,245760,(null as any),0,i6.AppComponent,[i5.Router,i7.TranslateService,
          i8.UtilService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i6.AppComponent> = i1.ɵccf('app-root',
    i6.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYXBwL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL2FwcC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG48YW5ndWxhci1sb2FkZXI+PC9hbmd1bGFyLWxvYWRlcj5cbiA8ZGl2IGNsYXNzPSdzYW5kb3MtY29udGFpbmVyJz5cbiAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuPC9kaXY+XG4iLCI8YXBwLXJvb3Q+PC9hcHAtcm9vdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsMENBQ0E7TUFBQTtNQUFBLCtFQUFBO01BQUE7TUFBaUMsMkNBQ2hDO1VBQUE7VUFBQSw0Q0FBOEI7VUFBQSxXQUM3QjtVQUFBO2FBQUE7MERBQUE7VUFBQSw2QkFBK0IsMENBQzNCO2lCQUFBO0lBSE47SUFFRTs7OztvQkNIRjtNQUFBO2FBQUE7d0JBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts